import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { mcpEndpoints } from '@/modules/mcp/constants';

import { mcpQueryKeys } from './queryKeys';

/** The signed-in user's AI apps connected through Finlay MCP. */
export const useMcpConnectionsQuery = () => {
  return useQuery({
    queryKey: mcpQueryKeys.connections(),
    queryFn: async () => {
      const { data } = await fetchClient.GET(mcpEndpoints.connections);
      return data ?? [];
    },
    // Connecting happens in the AI app, so refetch when the user comes back.
    refetchOnWindowFocus: 'always',
  });
};
